import {AuthInfo, AuthService, ParameterService} from 'energy-frame-lib';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '@env/environment';

@Injectable({providedIn: 'root'})
export class RegionalAuthService extends AuthService {


  constructor(protected _http: HttpClient,
              parameterService: ParameterService) {
    super(_http, parameterService);

    // initialize auth service to use application client for login
    this.setApplicationBasePath(this._authBasePath);
    this.setLogoutRedirectUiUrl('');
  }

  readonly _defaultAuthBasePath = '/api/auth/energy-sales-regionalplatform';

  readonly _authBasePath = this.initAuthBasePath();

  readonly _baseUrl = RegionalAuthService.initBaseUrl();


  private static initBaseUrl(): string {
    let baseUrl = window.location.protocol + '//' + window.location.hostname;
    if (window.location.port !== undefined && window.location.port !== '') {
      // SEP-274 - Wrong redirect URL on logout if a standard port (80 or 443) is used
      baseUrl += ':' + window.location.port;
    }
    return baseUrl;
  }

  realmLogin(realm: string) {
    const currentPath = window.location.href;
    let loginUrl = this._authBasePath +
        '/login?state=' +
        encodeURIComponent(currentPath) +
        '&requiredTenant=' +
        encodeURIComponent('false') +
        '&appfrmRealm=' +
        encodeURIComponent(realm);
    window.location.href = loginUrl;
  }

  logout() {
    this.disableCheckTokenHeartBeat();

    this._http
      .request('POST', this._authBasePath + '/logout', {
        headers: {Accept: 'application/json, text/plain, */*'},
        withCredentials: true
      })
      .subscribe(() => {
        // force loading the start page after the logout
        this.authInfo = undefined;
        window.location.href = this._baseUrl;
      });
  }

  initAuthBasePath() {
    // the base URL of the environment is actually the one from the backend
    if (environment.baseUrl && environment.baseUrl.length > 0) {
      return environment.baseUrl + this._defaultAuthBasePath;
    }
    return this._defaultAuthBasePath;
  }

  getAuthInfo(): Observable<AuthInfo> {
    // if there is valid authInfo in the service 'cache', return as observable
    if (this.authInfo) {
      return of(this.authInfo);
    }
    // else, create a new Observable and pipe the result to the service 'cache'
    return new Observable((observer) => {
      this._http
        .get(this._authBasePath + '/authinfo', {withCredentials: true})
        .pipe(map((res: AuthInfo) => this.authInfo = res))
        .subscribe((res) => {
          observer.next(res);
          observer.complete();
        }, (err) => {
          return observer.error(err);
        });
    });
  }
}
